const findIndex = (arr: any[], identifier: string, searchValue: any) => arr.findIndex(item => item[identifier] === searchValue);

export default findIndex;
